import { ConfigProvider, ThemeConfig } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { memo, useMemo } from 'react';
import { IBaseProps } from 'src/types';

function ConfigAntdProvider({ children }: IBaseProps) {
  const theme = useMemo<ThemeConfig>(() => {
    return {
      token: {
        fontFamily: 'Lexend',
        // colorPrimary: colorNormal,
      },
      components: {
        // Layout: {
        //   headerBg: 'white',
        //   bodyBg: 'white',
        //   footerBg: 'white',
        // },
      },
    };
  }, []);

  return (
    <ConfigProvider locale={viVN} theme={theme}>
      {children}
    </ConfigProvider>
  );
}

export default memo(ConfigAntdProvider);
